<template>
  <el-dialog
    :title="title"
    :visible.sync="isVisible"
    width="1100px"
    height="600px"
    append-to-body
    @close="isVisible = false">
    <div style="font-size: 16px">
      <div class="search">
        <el-select
          v-model="searchKeyword"
          placeholder="请选择"
          style="margin-right: 10px">
          <el-option
            v-for="item in selectList"
            :key="item.code"
            :label="item.value"
            :value="item.code">
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>

      <div class="nodes">
        <div style="margin-right: 10px">学位名称 (GB/T 6864):</div>
        <div v-for="(item, index) in currentList" :key="index">
          <span> {{ item.value }}</span>
          <span
            v-if="currentList.length - 1 != index"
            style="margin: 0 5px; color: #000">
            >
          </span>
        </div>
        <div
          style="margin-left: 10px; cursor: pointer"
          @click="handleUnCurrentList">
          <span style="color: #000">[</span> 返回
          <span style="color: #000">]</span>
        </div>
      </div>
      <div class="orgList" style="font-size: 14px">
        <div class="orgItme" v-for="(item, index) in defaultList" :key="index">
          <div @click="handleOrgList(item)">
            {{ item.value }}
          </div>
        </div>
      </div>
      <div>
        <div>
          <span @click="handleClear" style="cursor: pointer; color: #1d8ade">
            <span style="color: #000">[</span> 清空
            <span style="color: #000">]</span>
          </span>
          当前选择的是:
          {{
            currentList[currentList.length - 1]
              ? currentList[currentList.length - 1].value
              : ""
          }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleChage">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import new_json_xl from "@/assets/json/new_json_xl";
import new_json_xw from "@/assets/json/new_json_xw";
import json_zy from "@/assets/json/json_zy";
export default {
  name: "xl_xw_dialog",

  data() {
    return {
      title: "添加",
      isVisible: false,
      schoolId: undefined,
      formData: {},
      rules: {},
      currentList: [],
      defaultList: [],
      selectList: [],
      searchKeyword: undefined,
      isSearchKeywod: false,
      type: "xl",
    };
  },
  methods: {
    show(type, title, code) {
      this.type = type;
      this.title = title;
      this.defaultList = [];
      this.isSearchKeywod = false;
      this.searchKeyword = undefined;
      this.selectList = [];
      if (this.type == "xw") {
        this.defaultList = new_json_xw;
        new_json_xw.forEach((item) => {
          this.selectList.push(item);
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              this.selectList.push(itemm);
            });
          }
        });
      }
      if (this.type == "xl") {
        this.defaultList = new_json_xl;
        new_json_xl.forEach((item) => {
          this.selectList.push(item);
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              this.selectList.push(itemm);
            });
          }
        });
      }
      if (this.type == "zy") {
        this.defaultList = json_zy;
        json_zy.forEach((item) => {
          this.selectList.push(item);
          if (item.sub.length > 0) {
            item.sub.forEach((itemm) => {
              this.selectList.push(itemm);
              if (itemm.sub.length > 0) {
                itemm.sub.forEach((itemmm) => {
                  this.selectList.push(itemmm);
                });
              }
            });
          }
        });
      }

      this.isVisible = true;
      if (code) {
        const array = this.defaultList;
        if (this.type == "zy") {
          for (let index = 0; index < array.length; index++) {
            const item = array[index];
            if (item.code == code) {
              this.currentList = [item];
              if (item.sub.length > 0) {
                this.defaultList = item.sub;
              } else {
                this.defaultList = [];
              }
              return;
            } else {
              if (item.sub.length > 0) {
                const arraysub = item.sub;
                for (let index = 0; index < arraysub.length; index++) {
                  const itemm = arraysub[index];
                  if (itemm.code == code) {
                    this.currentList = [item, itemm];
                    if (itemm.sub.length > 0) {
                      this.defaultList = itemm.sub;
                    } else {
                      this.defaultList = [];
                    }
                    return;
                  } else {
                    if (itemm.sub.length > 0) {
                      const arraysubs = itemm.sub;
                      for (let index = 0; index < arraysubs.length; index++) {
                        const itemmm = arraysubs[index];
                        if (itemmm.code == code) {
                          this.currentList = [item, itemm, itemmm];
                          if (itemmm.sub.length > 0) {
                            this.defaultList = itemmm.sub;
                          } else {
                            this.defaultList = [];
                          }
                          return;
                        }
                      }
                    } else {
                      this.defaultList = [];
                    }
                  }
                }
              } else {
                this.defaultList = [];
              }
            }
          }
        } else {
          for (let index = 0; index < array.length; index++) {
            const item = array[index];
            if (item.code == code) {
              this.currentList = [item];
              if (item.isParent) {
                this.defaultList = item.sub;
              } else {
                this.defaultList = [];
              }
              return;
            } else {
              if (item.isParent) {
                const arraysub = item.sub;
                for (let index = 0; index < arraysub.length; index++) {
                  const itemm = arraysub[index];
                  if (itemm.code == code) {
                    this.currentList = [item, itemm];
                    if (itemm.isParent) {
                      this.defaultList = itemm.sub;
                    } else {
                      this.defaultList = [];
                    }
                    return;
                  }
                }
              } else {
                this.defaultList = [];
              }
            }
          }
        }
      }
      this.$forceUpdate();
    },

    handleChage() {
      const item = this.currentList[this.currentList.length - 1];
      if (item && item.value) {
        this.isVisible = false;
        this.$emit("handleChage", { ...item, type: this.type });
      } else {
        if (this.type == "xl") {
          this.$message.warning("请选择学历");
        }
        if (this.type == "xw") {
          this.$message.warning("请选择学位");
        }
        if (this.type == "zy") {
          this.$message.warning("请选择专业");
        }
      }
    },

    handleOrgList(item) {
      if (this.isSearchKeywod) {
        this.currentList = [];
        let code = item.code;
        if (this.type == "xw") {
          this.defaultList = new_json_xw;
        }
        if (this.type == "xl") {
          this.defaultList = new_json_xl;
        }
        if (this.type == "zy") {
          this.defaultList = json_zy;
        }

        if (code) {
          const array = this.defaultList;
          if (this.type == "zy") {
            for (let index = 0; index < array.length; index++) {
              const item = array[index];
              if (item.code == code) {
                this.currentList = [item];
                if (item.sub.length > 0) {
                  this.defaultList = item.sub;
                } else {
                  this.defaultList = [];
                }
                return;
              } else {
                if (item.sub.length > 0) {
                  const arraysub = item.sub;
                  for (let index = 0; index < arraysub.length; index++) {
                    const itemm = arraysub[index];
                    if (itemm.code == code) {
                      this.currentList = [item, itemm];
                      if (itemm.sub.length > 0) {
                        this.defaultList = itemm.sub;
                      } else {
                        this.defaultList = [];
                      }
                      return;
                    } else {
                      if (itemm.sub.length > 0) {
                        const arraysubs = itemm.sub;
                        for (let index = 0; index < arraysubs.length; index++) {
                          const itemmm = arraysubs[index];
                          if (itemmm.code == code) {
                            this.currentList = [item, itemm, itemmm];
                            if (itemmm.sub.length > 0) {
                              this.defaultList = itemmm.sub;
                            } else {
                              this.defaultList = [];
                            }
                            return;
                          }
                        }
                      } else {
                        this.defaultList = [];
                      }
                    }
                  }
                } else {
                  this.defaultList = [];
                }
              }
            }
          } else {
            for (let index = 0; index < array.length; index++) {
              const item = array[index];
              if (item.code == code) {
                this.currentList = [item];
                if (item.isParent) {
                  this.defaultList = item.sub;
                } else {
                  this.defaultList = [];
                }
                return;
              } else {
                if (item.isParent) {
                  const arraysub = item.sub;
                  for (let index = 0; index < arraysub.length; index++) {
                    const itemm = arraysub[index];
                    if (itemm.code == code) {
                      this.currentList = [item, itemm];
                      if (itemm.isParent) {
                        this.defaultList = itemm.sub;
                      } else {
                        this.defaultList = [];
                      }
                      return;
                    }
                  }
                } else {
                  this.defaultList = [];
                }
              }
            }
          }
        }
      } else {
        this.currentList.push(item);

        if (this.type == "zy") {
          if (item.sub.length > 0) {
            this.defaultList = item.sub;
          } else {
            this.defaultList = [];
          }
        } else {
          if (item.isParent) {
            this.defaultList = item.sub;
          } else {
            this.defaultList = [];
          }
        }
      }
    },
    async handleSearch() {
      if (this.searchKeyword) {
        this.isSearchKeywod = true;

        this.selectList.forEach((item, index) => {
          if (item.code == this.searchKeyword) {
            this.defaultList = [item];
          }
        });
      } else {
        this.$message.warning("请输入工作单位在点击查询");
      }
    },

    handleClear() {
      if (this.currentList.length == 0) {
        return this.$message.warning("当前已是根节点无需清空");
      }
      if (this.type == "xw") {
        this.defaultList = new_json_xw;
      }
      if (this.type == "xl") {
        this.defaultList = new_json_xl;
      }
      if (this.type == "zy") {
        this.defaultList = json_zy;
      }
      this.currentList = [];
      this.searchKeyword = undefined;
    },
    handleUnCurrentList() {
      if (this.currentList.length > 0) {
        const item = this.currentList[this.currentList.length - 1];
        if (this.type == "xw") {
          this.defaultList = new_json_xw;
        }
        if (this.type == "xl") {
          this.defaultList = new_json_xl;
        }
        if (this.type == "zy") {
          this.defaultList = json_zy;
        }

        if (item.parentCode != "." && this.currentList.length > 1) {
          let data = [];
          if (this.type == "xw") {
            data = new_json_xw.find((e) => item.parentCode == e.code);
          }
          if (this.type == "xl") {
            data = new_json_xl.find((e) => item.parentCode == e.code);
          }
          if (this.type == "zy") {
            data = json_zy.find((e) => item.parentCode == e.code);
          }
          this.defaultList = data.sub;
          this.currentList = [data];
        } else {
          this.currentList = [];
        }
      } else {
        this.$message.warning("当前已是根节点无法返回");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .searchInput {
    width: 200px;
    margin-right: 20px;
  }
}
.nodes {
  display: flex;
  flex-wrap: wrap;
  color: #1d8ade;
}
.orgList {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 22px;
  padding: 20px;
  .orgItme {
    width: 200px;
    color: red;
    cursor: pointer;
  }
}
</style>
